export default __webpack_public_path__ + "static/media/Infinity.06608dcb.svg";